// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"bb70ee17","513":"b41c7675","703":"c2664009","787":"216f88e1","968":"d0603714"}[chunkId] + ".chunk.js";
};